import {
  changeQuestionClearOnHide,
  getIsDataCarChangedRenewal,
  getQuotationIsFromRenewal,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const drivingWheelLocation = {
  drivingWheelLocationChange() {
    const isFromRenewal = getQuotationIsFromRenewal();
    const isCarCountryFirstRegistrationChange = getIsDataCarChangedRenewal(
      'firstRegistrationCountry'
    );

    if (isFromRenewal && !isCarCountryFirstRegistrationChange) {
      changeQuestionClearOnHide(
        FieldsEnum.CarDrivingWheelLocation,
        FormsEnum.CalculationForm,
        false
      );

      setQuestionVisibility({
        key: FieldsEnum.CarDrivingWheelLocation,
        visible: false,
        formName: FormsEnum.CalculationForm,
      });
    }
  },
};

export default drivingWheelLocation;
